import { useEffect } from "react";
import { Col, Row, Typography, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import CustomInput from "../../components/CustomInput/Input";
import { entNameRules, scTenureRules } from "../../helpers/helpers";
import CustomButton from "../../components/CustomButton/Button";
import { BTN_TXT } from "../../constants/constants";
import { useNavigate } from "react-router-dom";
import { getInvDropdown } from "../../redux/slices/InvoiceuploadSlice";
import { DEAL_CATEGORY_IDS } from "../../helpers/dealCategoryProducts";
import "./SupplyChainUpload.scss";

const { Title } = Typography;

const SupplyChainUpload = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { entList } = useSelector((state) => state?.invoiceUpload);
  const dealCategoryId = DEAL_CATEGORY_IDS.SUPPLY_CHAIN_FINANCE;

  useEffect(() => {
    dispatch(getInvDropdown(dealCategoryId));
  }, [dispatch, dealCategoryId]);

  const handleUploadSCF = (values) => {
    const selectedEnt = entList.find(
      (item) => item.busEntId === values.entName
    );

    if (!selectedEnt) {
      return;
    }


    navigate("/upload-supply-chain-files", {
      state: {
        selectedEnt,
        selectedEnterprise: selectedEnt,
        selectedBusEntId: values.entName,
        tenure: values.tenure,
        dealCategoryId,
      },
    });
  };

  return (
    <>
      <Title level={3} style={{ margin: 0, fontSize: 24 }}>
        Supply Chain Financing Upload
      </Title>
      <Form
        layout="vertical"
        onFinish={handleUploadSCF}
        initialValues={{ remember: true }}
        className="invoice-upload-form"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} md={10}>
            <CustomSelect
              label="Enterprise Name"
              name="entName"
              showSearch
              placeholder="Select Enterprise"
              className="custom-ent-select"
              options={entList.map((item) => ({
                value: item.busEntId,
                label: item.entName,
              }))}
              rules={entNameRules}
            />
          </Col>
          <Col xs={24} md={10}>
            <CustomInput
              label="Tenure"
              name="tenure"
              type="text"
              placeholder="Enter Tenure (Min 30 Days - Max 120 Days)"
              rules={scTenureRules}
            />
          </Col>
          <Col xs={24} md={4}>
            <Form.Item>
              <CustomButton
                type="primary"
                htmlType="submit"
                block
                style={{ padding: 24, marginTop: 32 }}
              >
                {BTN_TXT.UPLOAD_SCF}
              </CustomButton>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default SupplyChainUpload;

